import { CommonModule } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  selector: 'app-gallery-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './gallery-layout.component.html',
  styleUrls: ['./gallery-layout.component.css'],
})
export default class GalleryLayoutComponent {
  private readonly router = inject(Router);

  private currentUrl = toSignal(
    this.router.events.pipe(map(() => this.router.url)),
    { initialValue: this.router.url }
  );

  activeTab = computed<'news' | 'photo-gallery' | 'video-gallery'>(() => {
    const url = this.currentUrl();

    if (url.includes('/gallery/news')) return 'news';
    if (url.includes('/gallery/photo-gallery')) return 'photo-gallery';
    if (url.includes('/gallery/video-gallery')) return 'video-gallery';

    return 'news';
  });

  changeTab(tab: 'news' | 'photo-gallery' | 'video-gallery') {
    this.router.navigate(['/gallery', tab]);
  }
}
